import React from 'react';
import {View, Text, TouchableOpacity, StyleSheet} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {clearFocusedOrder, selectFocusedOrder} from '../../actions/ScanToCartScanningActions';

const FocusBar = () => {
  const dispatch = useDispatch();
  const focusedOrder = useSelector(selectFocusedOrder);

  if (!focusedOrder) return null;

  return (
    <View style={styles.container} testID="focusBar">
      <Text style={styles.title} numberOfLines={1}>Viewing order #{focusedOrder.increment_id}</Text>
      <TouchableOpacity
        style={styles.backButton}
        accessibilityRole="button"
        accessibilityLabel={`Back to all orders from order #${focusedOrder.increment_id}`}
        testID="focusBarBack"
        onPress={() => dispatch(clearFocusedOrder())}>
        <Text style={styles.backText}>Back</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#000',
    paddingVertical: 8,
    paddingHorizontal: 16
  },
  title: {
    color: '#fff',
    fontSize: 19,
    flexShrink: 1,
    marginRight: 12,
    fontFamily: 'Poppins_600SemiBold',
    fontWeight: 'bold'
  },
  backButton: {
    backgroundColor: '#41970f',
    paddingVertical: 6,
    paddingHorizontal: 16,
    borderRadius: 5
  },
  backText: {
    color: '#fff',
    fontSize: 15,
    fontWeight: 'bold'
  }
});

export default FocusBar;
